import api from './apiCore';
import './apiEndpoints';

export default api;
